// extracted by mini-css-extract-plugin
export default {"checkbox-container":"styles_checkbox-container__0ORxL","checkboxContainer":"styles_checkbox-container__0ORxL","checkbox":"styles_checkbox__8bi0m"};